<template>
  <article class="login__banner">
    <figure>
      <picture>
        <!-- <source media="(min-width:50rem )" srcset="./../images/banner-desktop.jpg" /> -->
        <img src="@/assets/images/banner-mobile.jpg" alt="" />
      </picture>
    </figure>
  </article>
</template>
